import { Building, Building2, Truck, Users } from "lucide-react";
import { FilterLiveForm, useGetIdentity } from "ra-core";
import { useQuery } from "@tanstack/react-query";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { SearchInput } from "@/components/admin/search-input";

import { FilterCategory } from "../filters/FilterCategory";
import { supabase } from "../providers/supabase/supabase";
import { sizes } from "./sizes";

export const CompanyListFilter = () => {
  const { identity } = useGetIdentity();
  return (
    <div className="w-52 min-w-52 flex flex-col gap-8">
      <FilterLiveForm>
        <SearchInput source="q" />
      </FilterLiveForm>

      <FilterCategory icon={<Building className="h-4 w-4" />} label="Size">
        {sizes.map((size) => (
          <ToggleFilterButton
            className="w-full justify-between"
            label={size.name}
            key={size.name}
            value={{ size: size.id }}
          />
        ))}
      </FilterCategory>

      <ChannelFilterSection />

      <FilterCategory
        icon={<Building2 className="h-4 w-4" />}
        label="Corporate Group"
      >
        <FilterLiveForm>
          <SearchInput source="corporate_group" />
        </FilterLiveForm>
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label="Account Manager"
      >
        <ToggleFilterButton
          className="w-full justify-between"
          label={"Me"}
          value={{ sales_id: identity?.id }}
        />
      </FilterCategory>
    </div>
  );
};

const ChannelFilterSection = () => {
  const { data: channels } = useQuery({
    queryKey: ["channels"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("channels")
        .select("id, name")
        .order("sort_order");
      if (error) throw error;
      return data as { id: number; name: string }[];
    },
  });

  if (!channels?.length) return null;

  return (
    <FilterCategory
      icon={<Truck className="h-4 w-4" />}
      label="Sales Channel"
    >
      {channels.map((ch) => (
        <ToggleFilterButton
          key={ch.id}
          className="w-full justify-between"
          label={ch.name}
          value={{ channel_id: ch.id }}
        />
      ))}
    </FilterCategory>
  );
};
